// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"56":"cbb8cabf","97":"ca7a1cda","108":"c3907bcc","149":"2e808c6d","162":"836d1fa6","314":"1fc70317","334":"9982f227","385":"a7b5f342","409":"e1b605a5","565":"5d27de76","581":"80a9a8db","649":"f7085531","661":"edb4a861","771":"a051ef37","890":"aeabacad"}[chunkId] + ".js";
};